import * as React from 'react';
import GamesTable from './GameTable';

function GameDashboard() {
  return (
    <div>
      <GamesTable />
    </div>
  );
}

export default GameDashboard;
